import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/motion/Reveal";

export default function FAQSection({ items, heading = "Frequently Asked Questions", eyebrow = "Answers" }) {
  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-paper">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-brand mb-4">{eyebrow}</p>
            <h2 className="font-display text-4xl md:text-5xl leading-none tracking-tight text-ink font-light">
              {heading}
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {items.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-line"
              >
                <AccordionTrigger className="text-left font-display text-xl md:text-2xl text-ink hover:text-brand hover:no-underline py-6 font-medium">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-base md:text-lg text-sage leading-relaxed pb-7 max-w-3xl">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
